"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widthQuery = matchMedia("(max-width: 768px)");
var touchabilityQuery = matchMedia("(pointer: coarse), (-moz-touch-enabled: 1)");
var pointerQuery = matchMedia("(any-pointer: fine)");
exports.isSmallWindow = !!widthQuery.matches;
exports.touchable = !!touchabilityQuery.matches;
exports.pointerAvailable = !!pointerQuery.matches;
function onWindowSizeChange(callback) {
    widthQuery.addListener(function (_a) {
        var matches = _a.matches;
        return callback(!!matches);
    });
}
exports.onWindowSizeChange = onWindowSizeChange;
function onTouchabilityChange(callback) {
    touchabilityQuery.addListener(function (_a) {
        var matches = _a.matches;
        return callback(!!matches);
    });
}
exports.onTouchabilityChange = onTouchabilityChange;
function onPointerChange(callback) {
    pointerQuery.addListener(function (_a) {
        var matches = _a.matches;
        return callback(!!matches);
    });
}
exports.onPointerChange = onPointerChange;



//////////////////
// WEBPACK FOOTER
// ./src/infra/media.ts
// module id = 599
// module chunks = 0